import { useState, useEffect } from "react";

function useForm(callback, validate, initialState) {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOnChange = (e, property) => {
    const { name, value } = e.target;

    if (property && property === "modules") {
      setValues((prev) => ({
        ...prev,
        modules: values.modules.map((ele) => {
          if (name === ele.module) {
            const changes = {
              ...ele,
              name: value,
            };

            return {
              ...changes,
            };
          }

          return ele;
        }),
      }));

      return;
    }

    if (!property) {
      if (name === "isOverride") {
        const { checked } = e.target;
        setValues((prev) => ({ ...prev, [name]: checked }));

        return;
      }

      const split = value.split("-");
      const term_code = split[0];
      const open_year = split[1];

      const formatData = {
        term_code,
        open_year,
      };

      setValues((prev) => ({ ...prev, [name]: formatData }));
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    // setErrors(validate(values));
    setErrors({});
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(initialState).length !== 0) {
      setValues(initialState);
    }
  }, [initialState]);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return {
    handleOnChange,
    handleOnSubmit,
    values,
    errors,
  };
}

export default useForm;
